import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'

import { connect, useSelector } from 'react-redux'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import { Item } from '../../common/snippets'
import { SplitButton } from '../../common/SplitButton'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../common/svg/refresh'
import * as id from './reportId'
import * as lb from './reportLables'
import { ReportHeading } from './common/ReportHeading'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../common/helper'
import moment from 'moment'
import * as url from './oldReportsUrls'
import { getBranchReceiveFilter } from '../../../store/reports/reports_action'
import { PaymentTypesOptions, reportViewOpt, urls } from '../../common/constants'
import BranchReceive from './BranchTransfer/BranchReceive'
import Alert from '../../common/alert'
import { updateLoader, updateModal } from '../../../store/common/common_action'
import { GetRequest } from '../../common/api'
import ManageColumns from '../../common/ManageColumnsUI'
import * as mdt from '../../common/modaltypes'
import { BranchReceiveHeader, BranchReceiveHeaderForBoth, BranchReceiveHeaderFormatedLR, BranchReceiveHeaderForPortrait, BranchReceiveHeaderForRemoveGST } from './BranchTransfer/excelTable/BranchReceiveConstant'
import { RAJESH_TRANSPORT } from '../../../helper/companyIdhardcode'
const BranchReceiveReport = (props) => {
  const {
    data: { common, reports },
    getBranchReceiveFilter,
    updateLoader,
    updateModal
  } = props
  const companySetting = useSelector((state) => state?.common?.companySettings[0])
  const loginCountryId = companySetting?.DefaultCurrencyID;
  const { loginData, roleRights, showModal, modalType,companySettings } = common
  const { intCompanyID, intUserID, IsAdmin, intBranchID } = loginData
  const reportName = 'Branch Transfer Received'
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports || 0
  const BranchTransferReceivePortrait = companySettings?.[0]?.BranchTransferReceivePortrait || 0
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const [selCompany, setSelCompany] = useState(false)

  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selFromBranch, setSelFromBranch] = useState('')
  const [selToBranch, setSelToBranch] = useState('')
  const [selVehicle, setSelVehicle] = useState('')

  const [receiveByBranchList, setReceiveByBranchList] = useState([])
  const [receiveToBranchList, setReceiveToBranchList] = useState([])
  const [vehicleList, setVehicleList] = useState([])
  const [resetFlag, setResetFlag] = useState(false)
  const [selPaymentType, setSelPaymentType] = useState(PaymentTypesOptions[0])
  const [selReportView, setselReportView] = useState(reportViewOpt[1])
  const [tableData, setTableData] = useState([])
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: ''
  })
  const [filterData, setFilterData] = useState({
    CompanyName: '',
    FromDate: '',
    ToDate: '',
    fromBranchName: '',
    toBranchName: '',
    VehicleNo: '',
    payment: '',
    Report: '',
  });
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [showReport, setShowReport] = useState(false)
  const [branchReceive, setBranchReceive] = useState({})
  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  useEffect(() => {
    if (!isEmpty(branchReceive)) {
      let TransferFromBranch = branchReceive.BranchRecieveFromBranch.map((el) => ({ id: el.FromBranchID, name: el.FromBranch }))
      setReceiveByBranchList(TransferFromBranch)
      
      let defaultBranch = TransferFromBranch.filter((obj) => obj?.id === intBranchID)
      if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0) {
        defaultBranch = TransferFromBranch.filter((obj) => obj?.id !== intBranchID)
      }

      const TransferToBranch = branchReceive.BranchRecieveToBranch.map((el) => ({ id: el.ToBranchID, name: el.ToBranch, FromBranchID: el.FromBranchID }))
      setReceiveToBranchList(TransferToBranch)
      const TransferVehicle = branchReceive.BranchRecieveVehicle.map((el) => ({ id: el.VehicleID, name: el.VehicleNo, FromBranchID: el.FromBranchID, ToBranchID: el.ToBranchID }))
      setVehicleList(TransferVehicle)
      if (defaultBranch.length) {
        setSelFromBranch(defaultBranch[0])
        if (TransferToBranch.length) {
          let defaultToBranch = TransferToBranch.filter((val) => val?.FromBranchID === defaultBranch[0]?.id)
          if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0) {
            defaultToBranch = TransferFromBranch.filter((obj) => obj?.FromBranchID !== intBranchID)
          }
          if (defaultToBranch.length) {
            setSelToBranch(defaultToBranch[0])
            if (TransferVehicle.length) {
              let defaultVehicle = TransferVehicle.filter((val) => val?.FromBranchID === defaultBranch[0]?.id && val?.ToBranchID === defaultToBranch[0]?.id)
              if (defaultVehicle.length) {
                setSelVehicle(defaultVehicle[0])
              }
            }
          }
        }
      } else {
        setSelFromBranch(TransferFromBranch[0])
        if (TransferToBranch.length) {
          let defaultToBranch = TransferToBranch.filter((val) => val?.FromBranchID === TransferFromBranch[0]?.id)
          if (defaultToBranch.length) {
            setSelToBranch(defaultToBranch[0])
            if (TransferVehicle.length) {
              let defaultVehicle = TransferVehicle.filter((val) => val?.FromBranchID === TransferFromBranch[0]?.id && val?.ToBranchID === defaultToBranch[0]?.id)
              if (defaultVehicle.length) {
                setSelVehicle(defaultVehicle[0])
              }
            }
          }
        }
      }
      if (disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0) {
        setSelToBranch({name:loginData?.strBranchName,id:loginData?.intBranchID})
      }

    } else {
      setReceiveByBranchList([])
      setReceiveToBranchList([])
      setVehicleList([])
      setSelFromBranch('')
      setSelToBranch('')
      setSelVehicle('')
      setResetFlag(!resetFlag)
    }
  }, [branchReceive])
  // useEffect(() => {
  //   const getLocalData = (key) => {
  //     return new Promise((resolve) => {
  //       const localData = localStorage.getItem(key)
  //       resolve(localData ? JSON.parse(localData) : null)
  //     })
  //   }
  //   const updateColumnDetails = async () => {
  //     const BranchReceiveHeaderCol=UseFormattedLRinReports===0||UseFormattedLRinReports===1?BranchReceiveHeader:UseFormattedLRinReports===2?BranchReceiveHeaderFormatedLR:BranchReceiveHeaderForBoth
  //     try {
  //       if (BranchTransferReceivePortrait === 1) {
  //         let usedCols = []
  //         const BranchReceiveHeaderForPortraitCol = await getLocalData('BranchReceiveHeaderForPortrait')
  //         if (UseFormattedLRinReports !== 3) {
  //           usedCols = (BranchReceiveHeaderForPortraitCol || BranchReceiveHeaderForPortrait).filter((item) => item.field !== 'FormattedLRNO');
  //         } else {
  //           usedCols = BranchReceiveHeaderForPortraitCol || BranchReceiveHeaderForPortrait
  //         }
  //         setManageColumn(usedCols)
  //       } else {
  //         const localBrnhTransfCol = await getLocalData('BranchTransferReceive1')
  //         const BranchReceiveRemoveGSTCol = await getLocalData('BranchReceiveHeaderForRemoveGST1')
  //         let usedCol = []
  //         if (loginCountryId === 2) {
  //           usedCol = BranchReceiveRemoveGSTCol || BranchReceiveHeaderForRemoveGST
  //         }else if(RAJESH_TRANSPORT=== intCompanyID){
  //           usedCol=usedCol.filter((col)=>col.field!=='GSTAmount' && col.field!=='GSTPercentage')
  //         } else {
  //           usedCol = localBrnhTransfCol || BranchReceiveHeaderCol
  //         }
  //         usedCol = usedCol.map((col) => {
  //           if (col.field === 'Valuation') {
  //             return {
  //               ...col,
  //               header: loginCountryId === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
  //               exportHead: loginCountryId === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
  //             };
  //           }
  //           return col;
  //         });
  //         console.log("usedCol",usedCol)
  //         setManageColumn(usedCol)
  //       }
        
  //     } catch (error) {
  //       setManageColumn(BranchTransferReceivePortrait===1?BranchReceiveHeaderForPortrait:loginCountryId===2?BranchReceiveHeaderForRemoveGST:BranchReceiveHeaderCol)
  //       console.error(error)
  //     }
  //   }
  //   updateColumnDetails()
  // }, [])
  useEffect(() => {
    const getLocalData = (key) => {
      return new Promise((resolve) => {
        const localData = localStorage.getItem(key)
        resolve(localData ? JSON.parse(localData) : null)
      })
    }

    const updateColumnDetails = async () => {
      const BranchReceiveHeaderCol =
        UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
          ? BranchReceiveHeader
          : UseFormattedLRinReports === 2
            ? BranchReceiveHeaderFormatedLR
            : BranchReceiveHeaderForBoth

      try {
        if (BranchTransferReceivePortrait === 1) {
          let usedCols = []
          const BranchReceiveHeaderForPortraitCol = await getLocalData('BranchReceiveHeaderForPortrait')
          if (UseFormattedLRinReports !== 3) {
            usedCols = (BranchReceiveHeaderForPortraitCol || BranchReceiveHeaderForPortrait).filter(
              (item) => item.field !== 'FormattedLRNO'
            )
          } else {
            usedCols = BranchReceiveHeaderForPortraitCol || BranchReceiveHeaderForPortrait
          }
          setManageColumn(usedCols)
        } else {
          const localBrnhTransfCol = await getLocalData('BranchTransferReceive1')
          const BranchReceiveRemoveGSTCol = await getLocalData('BranchReceiveHeaderForRemoveGST1')

          let usedCol = []
          if (loginCountryId === 2) {
            usedCol = BranchReceiveRemoveGSTCol || BranchReceiveHeaderForRemoveGST
          } else {
            usedCol = localBrnhTransfCol || BranchReceiveHeaderCol
          }

          // ✅ Rename valuation column based on country
          usedCol = usedCol.map((col) => {
            if (col.field === 'Valuation') {
              return {
                ...col,
                header: loginCountryId === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
                exportHead: loginCountryId === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
              }
            }
            return col
          })
          if (RAJESH_TRANSPORT === intCompanyID) {
            usedCol = usedCol.filter(
              (col) =>
                !['Sender','SenderGSTN', 'RecName','ReceiverGSTN', 'NetAmount', 'GrossAmount'].includes(col.field)
            )
            if (!usedCol.some((c) => c.field === 'Remarks')) {
              usedCol.push({
                id: 20,
                header: 'Remarks',
                exportHead: 'Remarks',
                field: 'Remarks',
                isSelected: true,
                isDefault: true,
                isMandatory: true,
                pdfColSx: {
                  minCellHeight: 36,
                  textColor: [0, 0, 0],
                  cellPadding: 6,
                  font: 'Roboto',
                  valign: 'middle',
                  halign: 'left',
                  fontSize: 12,
                  minCellWidth: 100,
                },
                xlCol: { dataType: 'string', dataFormatter: null, fontSize: 5 },
              })
            }
          }
          setManageColumn(usedCol)
        }
      } catch (error) {
        setManageColumn(
          BranchTransferReceivePortrait === 1
            ? BranchReceiveHeaderForPortrait
            : loginCountryId === 2
              ? BranchReceiveHeaderForRemoveGST
              : BranchReceiveHeaderCol
        )
        console.error(error)
      }
    }

    updateColumnDetails()
  }, [
    BranchTransferReceivePortrait,
    UseFormattedLRinReports,
    loginCountryId,
    RAJESH_TRANSPORT,
    intCompanyID,
  ])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
      setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])

  useEffect(() => {
    focusElemnt(id.fromDate)
  }, [])
  const handleClick2 = () => {
    if (selFromBranch === '' || selFromBranch === ' ') {
      setShowAlert({ show: true, message: "Please select From Branch" })
    } else if (selToBranch === '' || selToBranch === ' ') {
      setShowAlert({ show: true, message: "Please select To Branch" })
    } else if (selVehicle === '' || selVehicle === ' ') {
      setShowAlert({ show: true, message: "Please select Vehicle No" })
    } else {
      let baseUrl = url.branchReceive
      const urlData = url.branchReceiveReceive
      urlData.chk = loginData.BusCrsCheckSum
      urlData.FromDt = fromDate.format('DD-MMM-YYYY')
      urlData.ToDt = toDate.format('DD-MMM-YYYY')
      urlData.FromBranchId = selFromBranch?.id
      urlData.ToBranchId = selToBranch?.id
      urlData.VehicleNo = selVehicle?.name
      urlData.intAllowExportExcel = 1
      baseUrl = appendToUrl(baseUrl, urlData)
      window.open(baseUrl, '_blank')
    }
  }
  const callFilterAPi = () => {
    if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
      setShowAlert({ show: true, message: "This report cannot be taken for more than 31 days" })
    } else {
      const obj = {
        DateFrom: fromDate.format('YYYY-MM-DD'),
        DateTo: toDate.format('YYYY-MM-DD'),
        intBranchID: 0,
        intCompanyID,
      }
      getBranchReceiveFilter(obj).then((res) => {
        if (res?.status == 'Success') {
          if (res.Data[0].BranchRecieveFromBranch.length) {
            setBranchReceive(res.Data[0])
          } else {
            setBranchReceive({})
            setShowAlert({ show: true, message: 'No Data Found On Selected Date Range', nextId: '' })
          }
        } else {
          setShowAlert({ show: true, message: res.ErrMessage, nextId: '' })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
  }
  const generateReport = () => {
    setShowReport(false)
    setIsPdfLoading(false)
    if (selFromBranch === '' || selFromBranch === ' ') {
      setShowAlert({ show: true, message: "Please select From Branch" })
    } else if (selToBranch === '' || selToBranch === ' ') {
      setShowAlert({ show: true, message: "Please select To Branch" })
    } else if (selVehicle === '' || selVehicle === ' ') {
      setShowAlert({ show: true, message: "Please select Vehicle No" })
    } else {
      setFilterData({
        ...filterData,
        CompanyName: loginData.strCompanyName,
        FromDate: moment(new Date(fromDate)).format("DD-MMM-YYYY"),
        ToDate: moment(new Date(toDate)).format("DD-MMM-YYYY"),
        fromBranchName: selFromBranch?.name,
        toBranchName: selToBranch?.name,
        VehicleNo: selVehicle?.name,
        payment: selPaymentType?.Name,
        Report: selReportView?.name,
      })
      const body = {
        FromBranchID: selFromBranch?.id,
        ToBranchID: selToBranch?.id,
        CompanyID: intCompanyID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        PaymentTypeIDs: selPaymentType?.id,
        VehicleNo: selVehicle?.name,
      }
      updateLoader(true)
      GetRequest(urls.getBranchReceiveData, body).then((res) => {
        if (res.status == 'Success') {
          setShowReport(true)
          updateLoader(false)
          const data=res?.Data?.Table?.map((val)=>({...val,PaymentType:UseToPayAsCOD===1&&val.PaymentTypeID===2?'COD':val.PaymentTypeID===7?'COD(MANUAL)':val.PaymentTypeID===9?'COD(DDDV)':val.PaymentType}))
          setTableData(data)
        } else {
          updateLoader(false)
          setShowAlert({ show: true, message: res?.ErrMessage })
        }
      }).catch((err) => {
        updateLoader(false)
        console.log('Error:', err)
      })
    }
  }
  //handle Close Alert
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  const handleFromBranch = (val) => {
    setSelFromBranch(val)
    let toBranchList = receiveToBranchList?.filter((obj) => obj?.FromBranchID === val?.id);
    if (toBranchList.length) {
      if(disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport==0){
      }else{
        setSelToBranch(toBranchList[0])
      }
      let vehicleListFilter = vehicleList?.filter((obj) => obj.FromBranchID === val?.id && obj.ToBranchID === toBranchList[0]?.id)
      if (vehicleListFilter.length) {
        setSelVehicle(vehicleListFilter[0])
      } else {
        setSelVehicle(' ')
      }
    } else {
      setSelToBranch(' ')
      setSelVehicle(' ')
    }
  }
  const handleToBranch = (val) => {
    setSelToBranch(val)
    let vehicleListFilter = vehicleList?.filter((obj) => obj.FromBranchID === val?.FromBranchID && obj.ToBranchID === val?.id)
    if (vehicleListFilter.length) {
      setSelVehicle(vehicleListFilter[0])
    } else {
      setSelVehicle(' ')
    }
  }

  const onSaveColumns = (item) => {
    setManageColumn(item)
    localStorage.setItem(BranchTransferReceivePortrait===1?'BranchReceiveHeaderForPortrait':loginCountryId===2?'BranchReceiveHeaderForRemoveGST1':'BranchTransferReceive1', JSON.stringify(item))
  }
  let selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
  const mainHeader = ['sno', 'LRNO', 'ChallanNo', 'ReceiptDate', 'Sender', 'SenderGSTN', 'RecName', 'ReceiverGSTN', 'ItemDetails']
  if (UseFormattedLRinReports === 3) {
    const lrIndex = mainHeader.indexOf('LRNO');
    if (lrIndex !== -1) {
      mainHeader.splice(lrIndex + 1, 0, 'FormattedLRNO');
    }
  }
  const matchFields = Object.fromEntries(
    Object.entries(selectedFields).filter(([key]) => mainHeader.includes(key))
  );
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <ReportHeading reportName={reportName} />
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectCompnay}
            label={lb.select_company}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            onSelect={(val) => setSelCompany(val)}
            width="300px"
          />{' '}
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Receive Date`}
            name={'from_date'}
            value={fromDate}
            id={id.fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Receive  Date'}
            name={'to_date'}
            value={toDate}
            id={id.toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt(id.goButtonDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            variant="contained"
            id={id.goButtonDate}
            onClick={callFilterAPi}
            onKeyDown={(e) => {
              navigation3(e, id.selBranch, id.toDate, () => {
                callFilterAPi()
              })
            }}
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            label={'Transfer From Branch'}
            id={id.selBranch}
            defaultvalue={selFromBranch?.name || selFromBranch}
            value={selFromBranch?.name || selFromBranch}
            data={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport==1?receiveByBranchList?.filter((val)=>val.id==loginData?.intBranchID) :receiveByBranchList || []}
            dataKey={`name`}
            resetFlag={resetFlag}
            // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport==0}
            idKey={`id`}
            onSelect={(val) => handleFromBranch(val)}
            width="100%"
            nextId={id.destinationBranch}
            prevId={id.goButtonDate}
          />
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            label={'Received By Branch'}
            id={id.destinationBranch}
            data={receiveToBranchList?.filter((obj) => obj?.FromBranchID === selFromBranch?.id) || []}
            defaultvalue={selToBranch?.name || selToBranch}
            value={selToBranch?.name || selToBranch}
            disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport==0}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => handleToBranch(val)}
            resetFlag={resetFlag}
            width="100%"
            nextId={id.vehicle}
            prevId={id.selBranch}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label={lb.vehicle}
            id={id.vehicle}
            data={vehicleList?.filter((obj) => obj.FromBranchID === selFromBranch?.id && obj.ToBranchID === selToBranch?.id)}
            defaultvalue={selVehicle?.name || selVehicle}
            value={selVehicle?.name || selVehicle}
            resetFlag={resetFlag}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(vehicle) => setSelVehicle(vehicle)}
            width="100%"
            nextId={id.paymentType}
            prevId={id.destinationBranch}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label={lb.paymentType}
            id={id.paymentType}
            data={PaymentTypesOptions}
            searchPlaceholder={`Search By Payment`}
            defaultvalue={selPaymentType?.Name}
            HasAllSelect={true}
            disabled={true}
            dataKey={`Name`}
            idKey={`id`}
            onSelect={setSelPaymentType}
            nextId={id.reportView}
            prevId={id.vehicle}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label={lb.reportView}
            id={id.reportView}
            data={reportViewOpt}
            searchPlaceholder={`Search By Report`}
            defaultvalue={selReportView?.name}
            dataKey={`name`}
            disabled={true}
            idKey={`id`}
            onSelect={setselReportView}
            nextId={id.reportmainButton}
            prevId={id.paymentType}
          />
        </Item>
        <Item sx={sx.itemsx} onKeyDown={(e) => {
          navigation3(e, showReport ? isPdfLoading ? "backBtn" : disableExcel ? "exportPdf" : "exportExcelBtn" : id.fromDate, id.reportView, () => {
            generateReport()
          })
        }}>
          <SplitButton
            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
            hideToggle={false}
            id1={id.reportmainButton}
            onClick1={generateReport}
            onClick2={handleClick2}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, cursor: 'pointer' }} onClick={() => {
          setFromDate(moment(new Date()))
          setToDate(moment(new Date()))
          setSelVehicle('')
          setSelToBranch('')
          setSelFromBranch('')
          setReceiveByBranchList([])
          setReceiveToBranchList([])
          setVehicleList([])
          setResetFlag(!resetFlag)
        }} >
          <RefreshSvg />
        </Item>
      </Box>
      {showModal && mdt.BrnhTransferRecCol === modalType ? <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} /> : null}
      {showReport && <BranchReceive loginCountryId={loginCountryId} updateModal={updateModal} disableExcel={disableExcel} loginData={loginData} filterData={filterData} tableData={tableData} updateLoader={updateLoader} columnSummaryDefs={manageColumn.filter((obj) => obj.isSelected)} selectedFields={selectedFields} matchFields={matchFields} isPdfLoading={isPdfLoading} setIsPdfLoading={setIsPdfLoading} UseFormattedLRinReports={UseFormattedLRinReports}/>}
      {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}

    </Item>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchReceiveFilter, updateLoader, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(BranchReceiveReport)
